import ReferenceTypes from "./types"

const initialState: any = {
    userReference: null
}

export function userReferenceReducer(state = initialState, action: { type: string, payload: ReferenceTypes }) {
    switch (action.type) {
        case "POPULATE_USER_REFERENCE":
            return { ...state, userReference: action.payload }
        default:
            return state
    }
}